import { keepPreviousData, useMutation, useQuery } from '@tanstack/react-query'

import { queryClient } from '@/lib/queryClient'

import { meusComunicadosApi } from '../api/meusComunicadosApi'
import type { MeuComunicadoListFilters } from '../types/meuComunicado'

export const meusComunicadosKeys = {
  all: ['meus-comunicados'] as const,
  lists: () => [...meusComunicadosKeys.all, 'list'] as const,
  list: (filters: MeuComunicadoListFilters) => [...meusComunicadosKeys.lists(), filters] as const,
  imagens: (id: string) => [...meusComunicadosKeys.all, 'imagens', id] as const,
}

export function useMeusComunicados(filters: MeuComunicadoListFilters) {
  return useQuery({
    queryKey: meusComunicadosKeys.list(filters),
    queryFn: () => meusComunicadosApi.list(filters),
    placeholderData: keepPreviousData,
  })
}

export function useImagensMeuComunicado(id: string | undefined) {
  return useQuery({
    queryKey: meusComunicadosKeys.imagens(id ?? ''),
    queryFn: () => meusComunicadosApi.imagens(id as string),
    enabled: !!id,
  })
}

/** Idempotente — sem toast, só reflete o estado de "visualizado" na lista. */
export function useMarcarComunicadoVisualizado() {
  return useMutation({
    mutationFn: (id: string) => meusComunicadosApi.marcarVisualizado(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: meusComunicadosKeys.lists() })
    },
  })
}
